// extracted by mini-css-extract-plugin
export var loadingSpinner = "_54-1";
export var standaloneTable = "_54-0";